module.exports = __webpack_public_path__ + "static/media/pickup_icon.8fe5b6a9.svg";